export enum IRolNivel {
  Usuario = 0,
  ClienteFijo = 50, // no se pueden borrar (los roles nivel usuario no pueden adminsitrar estos roles)
  Administradores = 100, // no se pueden borrar y los fijos no pueden administrar estos roles
  SuperAdministradores = 500 // no se pueden borrar y los fijos no pueden administrar estos roles
}

export enum Roles {
  Admin = 1,
  
  /** Ahora Ejecutivo de Cuentas */
  Asesor = 2,
  EjecutivoCuenta = 2,

  Supervisor = 3,
  AdministradorMarca = 4,
  Operador = 5,
  /** obsoleto */
  GSA = 6,
  /** obsoleto */
  GSASub = 7,
  Agente = 8,

  /** Ahora es el Counter */
  AgenteEmisor = 9,
  Counter = 9,

  Vendedor = 10,
  APIInternal = 11,
  Administracion = 12,
  CentralAsistencia = 13,
}

export interface IRol {
  id: number;
  //codigo: string;
  nombre?: string;
  nombreKey?: string;
  //nivel?: IRolNivel;
  //permisos?: IPermisoAsignado[];
}

export interface IUsuarioRol{
  id:number;
  idusuario:number;
  idrol:number;
  rol: IRol;

  creafecha: Date;
  modifecha?: Date;
  bajafecha?: Date;
}